import { AxiosResponse, InternalAxiosRequestConfig } from 'axios'
import Storage from '@/lib/Storage'

export const request = (
  config: InternalAxiosRequestConfig
): InternalAxiosRequestConfig => {
  const { getAuthTokens } = Storage()
  const { accessToken, refreshToken } = getAuthTokens()

  const skipAuthOverride = config.headers?.['X-Skip-Auth-Override']

  if (config.headers && accessToken && refreshToken && !skipAuthOverride) {
    config.headers.Authorization = `Bearer ${accessToken}`
    config.headers['Stack-Refresh-Token'] = `Bearer ${refreshToken}`
  }

  if (config.headers && skipAuthOverride) {
    delete config.headers['X-Skip-Auth-Override']
  }

  return config
}

export const response = (response: AxiosResponse): AxiosResponse => {
  const { getAccessToken, setAuthTokens } = Storage()
  const { headers } = response

  // Only store refreshed tokens when the user is still authenticated.
  // A late-arriving response after logout() must not re-populate
  // localStorage with stale tokens.
  if (
    headers['Stack-Token'] &&
    headers['Stack-Refresh-Token'] &&
    getAccessToken()
  ) {
    setAuthTokens({
      accessToken: headers['Stack-Token'],
      refreshToken: headers['Stack-Refresh-Token']
    })
  }

  return response
}
